import { useContext, useMemo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import IOrderUI from "../../../models/IOrderUI";
import IOwTableCols from "../../../models/IOwTableCols";
import IPick_List from "../../../models/IPick_List";
import UserService from "../../../services/UserService";
import { OwStatusEnumIcon } from "../../shared/OwStatusEnumIcon/OwStatusEnumIcon";
import OwTable from "../../shared/OwTable/OwTable";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";

type Props = {
    order: IOrderUI;
};

export const OrderDetailView = ({ order }: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [isDataFetching, setIsDataFetching] = useState(true);

    useEffect(() => {
        setIsDataFetching(false);

        console.log(order.Pick_Lists);
    }, []);

    const renderPickListStatus = (row: IPick_List) => {
        return <div>{row.status_id ? <OwStatusEnumIcon status={row.status_id} /> : null}</div>;
    };

    const renderPickList = (row: IPick_List) => {
        return (
            <div>
                <span className={"me-2"}>
                    {row.is_locked ? <i className={"fad fa-lock-alt"} /> : <i className={"fad fa-lock-open-alt"} />}
                </span>
                <Link to={`/pick_lists/${row.guid}`}>{row.name}</Link>
            </div>
        );
    };

    const renderDateFn = (dateStr: string) => {
        return UserService.parseDate(dateStr);
    };

    const columns = useMemo(() => {
        return [
            {
                title: "pick_list",
                valueProp: "",
                renderFn: renderPickList,
                renderFnEmitsRow: true,
            },
            {
                title: "status",
                valueProp: "status",
                renderFn: renderPickListStatus,
                renderFnEmitsRow: true,
            },
            {
                title: "created_at",
                valueProp: "created_at",
                renderFn: renderDateFn,
            },
            {
                title: "updated_at",
                valueProp: "updated_at",
                renderFn: renderDateFn,
            },
        ] as IOwTableCols[];
    }, []);

    return (
        <div className={"OrderDetailView"}>
            <div className="row">
                <div className="col-12">
                    <OwTable
                        columns={columns}
                        dataSet={(order.Pick_Lists || []).filter((pickList) => pickList.deleted_at === null)}
                        userModel={userModel}
                        supplierModel={supplierModel}
                        dataFetch={isDataFetching}
                        initialData={false}
                    />
                </div>
            </div>
        </div>
    );
};
